export default __webpack_public_path__ + "static/media/1.bc0df53b.jpeg";